const riot = require('riot');

riot.tag2('atom-tag', '<div class="f fm fs10 rounded-4 bg-separator_opacity text-label_dark_medium word-break-keep lh15 py1 px4"><span>#</span><span>{opts.tag}</span></div>', 'atom-tag,[data-is="atom-tag"]{display:block}', '', function(opts) {
});